const initialState = {
  user: {
    name: "",
    image: "",
  },
  girl: {
    level: 0,
    name: "",
    age: "",
    description: "",
    address: "",
    image: "",
    isReplay: false,
  },
};

export default initialState;
